var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 39.999,
    viewBox: "0 0 40 39.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #5ab3f9;\n      }\n\n      .cls-3 {\n        opacity: 0.1;\n      }\n\n      .cls-4 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-5 {\n        fill: #040000;\n      }\n\n      .cls-6 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_2298",
    "data-name": "\\u77E9\\u5F62 2298",
    className: "cls-1",
    width: 11.186,
    height: 18.929
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_43238",
    "data-name": "\\u7EC4 43238",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35596",
    "data-name": "\\u8DEF\\u5F84 35596",
    className: "cls-2",
    d: "M199.542,26.544a20,20,0,1,1-20-20,20,20,0,0,1,20,20",
    transform: "translate(-159.542 -6.544)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_43229",
    "data-name": "\\u7EC4 43229",
    className: "cls-3",
    transform: "translate(14.407 10.957)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_43228",
    "data-name": "\\u7EC4 43228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_43227",
    "data-name": "\\u7EC4 43227",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35597",
    "data-name": "\\u8DEF\\u5F84 35597",
    className: "cls-5",
    d: "M184.808,21.284a5.739,5.739,0,0,1,.664.414q2.415,2,4.815,4.007a.878.878,0,0,1-.011,1.494l-4.088,3.408c-.051.043-.1.087-.165.145l1.1.916,3.181,2.65a.871.871,0,0,1,.006,1.459q-2.5,2.09-5.01,4.178a.863.863,0,0,1-.991.167.884.884,0,0,1-.5-.877q.006-3.087,0-6.173V32.84c-.077.072-.126.116-.172.162q-1.3,1.3-2.6,2.6a.864.864,0,0,1-1.2.12.854.854,0,0,1-.161-1.174,1.866,1.866,0,0,1,.186-.206q1.718-1.719,3.438-3.436c.047-.047.1-.085.164-.136-.068-.073-.112-.123-.159-.17q-1.745-1.745-3.489-3.49a.864.864,0,0,1-.1-1.212.851.851,0,0,1,1.177-.129,2.249,2.249,0,0,1,.2.187q1.269,1.266,2.535,2.535a1.457,1.457,0,0,1,.12.162l.059-.029v-.19c0-2,.011-4-.007-6.007a1.027,1.027,0,0,1,.708-1.144Zm3.683,5.163L185.549,24v4.9l2.942-2.452m0,8.6L185.554,32.6V37.5l2.937-2.447",
    transform: "translate(-179.513 -21.284)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_35598",
    "data-name": "\\u8DEF\\u5F84 35598",
    className: "cls-6",
    d: "M184.808,20.717a5.739,5.739,0,0,1,.664.414q2.415,2,4.815,4.007a.878.878,0,0,1-.011,1.494l-4.088,3.408c-.051.043-.1.087-.165.145l1.1.916,3.181,2.65a.871.871,0,0,1,.006,1.459q-2.5,2.09-5.01,4.178a.863.863,0,0,1-.991.167.884.884,0,0,1-.5-.877q.006-3.087,0-6.173v-.232c-.077.072-.126.116-.172.162q-1.3,1.3-2.6,2.6a.864.864,0,0,1-1.2.12.854.854,0,0,1-.161-1.174,1.866,1.866,0,0,1,.186-.206q1.718-1.719,3.438-3.436c.047-.047.1-.085.164-.136-.068-.073-.112-.123-.159-.17q-1.745-1.745-3.489-3.49a.864.864,0,0,1-.1-1.212.851.851,0,0,1,1.177-.129,2.249,2.249,0,0,1,.2.187q1.269,1.266,2.535,2.535a1.456,1.456,0,0,1,.12.162l.059-.029v-.19c0-2,.011-4-.007-6.007a1.027,1.027,0,0,1,.708-1.144Zm3.683,5.163-2.942-2.451v4.9l2.942-2.452m0,8.6-2.937-2.447V36.93l2.937-2.447",
    transform: "translate(-165.106 -10.181)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBle);
export default __webpack_public_path__ + "static/media/icon--ble.ec4d6511285b797b15d16926d9106378.svg";
export { ForwardRef as ReactComponent };